import { createSlice } from '@reduxjs/toolkit';
import { categoryRelevant } from './categoryAsyncThunk';

const categoryRelevantSlice = createSlice({
  name: "category",
  initialState: {
    payload: [],
    isLoading: false,
    isSuccess: false,
    isFail: false,
  },
  reducers: {},
  extraReducers: {
    [categoryRelevant.pending]: (state, action) => {
      state.isLoading = true;
      state.isSuccess = false;
      state.isFail = false;
    },
    [categoryRelevant.fulfilled]: (state, action) => {
      state.isLoading = false;
      state.isSuccess = true;
      state.payload = [...action.payload.list];
    },
    [categoryRelevant.rejected]: (state, action) => {
      state.isLoading = false;
      state.isFail = true;
    },
  },
});

export default categoryRelevantSlice.reducer;